import React, { Component } from 'react'

export default class Timeline extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">highlights</span>
                <h2 className="colorlib-heading animate-box">Timeline</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Internship at Cisco <span>July:2022-Semptember:2022</span></h2>
                        <p>I have completed a Intership as Application developer in under Cisco incubulation where I developed a full-stack ecommerce application</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                  <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Internship in Remote Care<span>2022:Mar - 2022:May</span></h2>
                        <p>Worked a frontend application developer using Flutter and integrated with backend from   Firebase</p>
                      </div>
                    </div>
                    {/* <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Primary and Higher Education <span>2005-2019</span></h2>
                        <p>I have completed my higher secondary education with major subjects as Physics,Chemistry & Maths with 95 merit. During my time at school, I have developed interest in solving complex problems of the fundamental physics which helped me to improve my understanding of any problem and also my mathematical skills to actually solve the problems.</p> 
                      </div>
                    </div> */}
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Undergraduation at UVCE(Bangalore University)<span>2020-2024</span></h2>
                        <p>I am pursuing my under-graduation studies with major in Information science . I have taken courses like DSA, OOPs, Computer Networks, CLoud computing , Web-Data Management over the years and have better understanding of these subjects.I have also been part of Marvel (R&D CLUB of the colleg ) scince my first year of college and also the GDSC(Google Developer Student Community).</p>
                      </div>
                    </div>
                  </article>
                 
                  <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none">
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
